'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styles = require('../styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var RuleText = _styledComponents2.default.span.withConfig({
  displayName: 'Rule__RuleText'
})(['align-self:center;margin:0 20px;']);

var StyledHr = _styledComponents2.default.hr.withConfig({
  displayName: 'Rule__StyledHr'
})(['flex-grow:1;border-color:', ';border:0;border-top:1px solid ', ';'], _styles.colors.grayLightLighter, _styles.colors.grayLight);

var Wrapper = _styledComponents2.default.div.withConfig({
  displayName: 'Rule__Wrapper'
})(['display:flex;justify-content:center;color:', ';'], _styles.colors.grayLight);

var Rule = function Rule(_ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, ['children']);

  return _react2.default.createElement(
    Wrapper,
    rest,
    _react2.default.createElement(StyledHr, null),
    _react2.default.createElement(
      RuleText,
      null,
      children
    ),
    _react2.default.createElement(StyledHr, null)
  );
};

Rule.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes2.default.node
} : {};

exports.default = Rule;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/li-components/lib/Modal2/Rule.js
// module id = 897
// module chunks = 14